import { render, staticRenderFns } from "./EModalMatriculasDisponiveis.vue?vue&type=template&id=54f573a6&scoped=true"
import script from "./EModalMatriculasDisponiveis.vue?vue&type=script&lang=js"
export * from "./EModalMatriculasDisponiveis.vue?vue&type=script&lang=js"
import style0 from "./EModalMatriculasDisponiveis.vue?vue&type=style&index=0&id=54f573a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f573a6",
  null
  
)

export default component.exports